import React from 'react';
import { useTranslation } from 'react-i18next';
import { FaExclamationTriangle } from 'react-icons/fa';
import './DeleteTransactionModal.css';

const DeleteTransactionModal = ({ isOpen, onClose, onConfirm, transaction }) => {
  const { t } = useTranslation();

  if (!isOpen) return null;

  const getTransactionDescription = () => {
    if (!transaction) return '';

    // Get the transaction type label
    const type = transaction.type || transaction.payment?.type || 'purchase';
    const typeLabel = type === 'sale' ? t('Income') :
                     type === 'purchase' ? t('Expense') :
                     type === 'takenLoan' ? t('Loan Taken') :
                     type === 'givenLoan' ? t('Loan Given') :
                     type === 'loanRepayment' ? t('Loan Repayment') :
                     type === 'repaymentReceived' ? t('Repayment Received') :
                     type === 'salaryPayment' ? t('Salary Payment') :
                     type === 'salaryAdvance' ? t('Salary Advance') :
                     type === 'salaryDeduction' ? t('Salary Deduction') :
                     type === 'transferIn' ? t('Transfer In') :
                     type === 'transferOut' ? t('Transfer Out') :
                     t(type);

    const description = transaction.description || transaction.payment?.description || '';
    const amount = transaction.amountPaid || transaction.payment?.amountPaid || transaction.value || 0;

    return `${typeLabel} - ${description} (${amount.toFixed(2)} ${t('l.e')})`;
  };

  return (
    <div className="transaction-delete-modal-overlay" onClick={onClose}>
      <div
        className="transaction-delete-modal-content"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="transaction-delete-modal-icon">
          <FaExclamationTriangle />
        </div>

        <h3>{t("Confirm Deletion")}</h3>

        <p className="delete-modal-message">
          {t("Are you sure you want to delete this transaction?")}
        </p>

        <div className="transaction-info">
          <strong>{getTransactionDescription()}</strong>
        </div>

        <p className="delete-modal-warning">
          {t("This action cannot be undone. All related data will be permanently deleted.")}
        </p>

        <div className="transaction-delete-modal-actions">
          <button className="button-secondary" onClick={onClose}>
            {t("Cancel")}
          </button>
          <button className="button-danger" onClick={onConfirm}>
            {t("Delete")}
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeleteTransactionModal;